import { FormatResponseTool } from './FormatResponseTool';

import { Heading } from '@/components/ui/heading';
import { HStack } from '@/components/ui/hstack';
import { VStack } from '@/components/ui/vstack';
import { type InquiryParticipant } from '@/hooks/useChat';

type SupportToolsPanelProps = {
  recipient: InquiryParticipant;
  onAppendToChat: (text: string) => void;
};

export function SupportToolsPanel({ recipient, onAppendToChat }: SupportToolsPanelProps) {
  return (
    <VStack className="h-full w-96 shrink-0 border-l border-outline-200 bg-background-0">
      <HStack className="items-center justify-between border-b border-outline-200 px-4 py-3">
        <Heading size="sm">Format expert response</Heading>
      </HStack>
      <FormatResponseTool recipient={recipient} onAppendToChat={onAppendToChat} />
    </VStack>
  );
}
